import React,{useState} from 'react'
import { ToastContainer } from 'react-toastify'
import logo from '../Assets/zamany_logo.webp'
import classes from './Login.module.css' 
import axios from 'axios';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom';


const Login = () => {

    const [msisdn,setMsisdn] = useState('')
    const [loading,setLoading] = useState(false)

    const navigate = useNavigate()

    const checkSubscription=async(number)=>{
         if(number.slice(0,3)==="234"){
        try {
            setLoading(true);
            console.log("msisdn", number);
            const data = { msisdn: number };
            const res = await axios.post(
              `https://adminfootball.gamewins.co.za/check-sub`,
              data
            );
            console.log("response", res);
            setLoading(false);
            if (res.data.result == 1) {
                console.log("redirect");
            //   router.push("/comedy-video");
            //   dispatch({ type: ACTION_TYPES.SET_USER, payload: res.data.userResult });
            localStorage.setItem('user',JSON.stringify(res.data.userResult));
            localStorage.setItem('msisdn',res.data.msisdn)
              if(res.data.userResult.packType=="WEEKLY" || "weekly"){
                Cookies.set("token","Authorized",{ expires: 7 })
                navigate("/");
              }
              else if(res.data.userResult.packType=="DAILY" || "daily"){
                Cookies.set("token","Authorized",{expires: 1 });
                navigate("/");
              }

            } else if (res.data.result == 0) {
              toast.error("You are not subscribed!");
            } else {
              toast.error("Something went wrong!");
            }
          } catch (error) {
            console.log(error);
            setLoading(false);
            toast.error(error?.data?.message || error?.message || error);
          }
    }
    }

    const submitHandler=(e)=>{
         e.preventDefault();
    console.log(msisdn);
    if (msisdn.length > 0) {
      // console.log(msisdn.slice(0,1));
      if (msisdn.slice(0, 3) !== "234" && msisdn.slice(0, 1) !== "0") {
        const countryCode = 234;
        const number = countryCode + msisdn.slice(0, msisdn.length);
        // const number=msisdn.concat(countryCode,msisdn);
        setMsisdn(number);
        checkSubscription(number);
        console.log(number, "nummber_1");
      }
      if (msisdn.slice(0, 1) === "0") {
        const countryCode = 234;
        const number = countryCode + msisdn.slice(1, msisdn.length);
        // const number=msisdn.concat(countryCode,msisdn);
        setMsisdn(number);
        checkSubscription(number);
        console.log(number, "nummber_2");
      } else {
        console.log("number_3", msisdn);
        checkSubscription(msisdn);
      }
    } else {
      toast.error("Input fields cannot be empty!");
    }
    }

  return (
    <div>
     
      <div className="bg-black h-screen">
        <ToastContainer />

        <div className="flex justify-center">
      
        </div>


<div className="px-5 mt-10">
<div class=" container mx-auto px-5 flex-col justify-center max-w-sm  bg-black  border border-gray-200 rounded-lg shadow-lg
  shadow-green-600 dark:bg-gray-800 dark:border-gray-700">
    <a href="#" className="flex justify-center">
    <img

        src={logo}
        alt="Logo"
        width={200}
        height={200}
        />
    </a>
    <div class="p-5">
    <form class="space-y-6" action="#" onSubmit={submitHandler}>
        <h5 class="text-xl font-medium text-gray-200 dark:text-white text-center">Sign in to Enjoy!</h5>
        <div>
            <label for="number" class="block mb-2 text-sm font-medium text-gray-200 dark:text-white">Enter Your Number</label>
            <input  type="text"
            placeholder="**********90"
              value={msisdn}
              onChange={(e) => setMsisdn(e.target.value)}
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                   required/>
        </div>
        
        <button  disabled={loading} 
        type="submit" class="w-full md:mx-auto text-white bg-green-600 hover:bg-green-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center ">Login </button>
       
    </form>
    </div>
  </div>
  </div>

        {loading && (
          <div className={classes.center_loader}>
            <div className={classes.loader}></div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Login
